import removeAccents from 'remove-accents'
import * as R from 'ramda'
import * as RA from 'ramda-adjunct'
import { METADATA_SUFFIX } from 'constants/api'

export const getBaseOrderValue = order => order.startsWith('-') ? order.substr(1) : order

const getOrderParamForApi = order => ({
  order: 'custom'
}[getBaseOrderValue(order)] || order)

export const formatStringForSearch = R.compose(
  R.toLower,
  removeAccents
)

export const getStringContains = searchedQuery => R.compose(
  R.contains(
    formatStringForSearch(searchedQuery)
  ),
  formatStringForSearch
)

export const getDataFromPayload = R.path(['data', 'data'])
export const getMetadataFromPayload = R.path(['data', 'metadata'])

export const payloadToState = R.curry((itemName, state, payload) => {
  state[itemName] = getDataFromPayload(payload)

  const metadata = getMetadataFromPayload(payload)

  if (!RA.isNilOrEmpty(metadata)) {
    state[itemName + METADATA_SUFFIX] = metadata
  }
})

export const sortBy = order => R.compose(
  order.startsWith('-') ? R.reverse : R.identity,
  R.isNil(order) ? R.identity : R.sortBy(R.prop(getBaseOrderValue(order)))
)

export const getApiParams = (defaultParams, modelParams) => {
  const apiParams = R.pick(R.keys(defaultParams), modelParams)

  if (apiParams.order) {
    const desc = apiParams.order.startsWith('-')

    const apiOrderParam = getOrderParamForApi(apiParams.order)

    apiParams.order = (desc && !apiOrderParam.startsWith('-') ? '-' : '') + apiOrderParam
  }

  if (apiParams.hasOwnProperty('idLanguage')) {
    apiParams.idLanguage = localStorage.ui_language_id
  }

  return apiParams
}

export const getOptimisticDelete = itemName => (state, { params }) => {
  state[itemName] = state[itemName].filter(item => item._id !== params.id)
}

export const getOptimisticDeleteAssignments = itemName => (state, { params }) => {
  state[itemName] = state[itemName].map(item => {
    if (item._id !== params.id) {
      return item
    }
    item.show = null
    item.episode = null
    item.state = 'BROADCAST_STATE_UNASSIGNED'
    return item
  })
}

export const pascalToCamelCase = str => str.charAt(0).toLowerCase() + str.substr(1)

export const camelToPascalCase = str => str.charAt(0).toUpperCase() + str.substr(1)

export const toSingular = str =>
  str.endsWith('s')
    ? str.substr(0, str.length - 1)
    : str

export const toPlural = str =>
  str.endsWith('s')
    ? str
    : str + 's'

export const getModuleName = ({ apiMethodsSuffix }) =>
  R.compose(toPlural, pascalToCamelCase)(apiMethodsSuffix)
